import { viperApi, clinicalApiPath } from '@/services/viper-api'

export const careTeamMemberService = {
  basePath: (orgId, orgTrialId) =>
    `${clinicalApiPath}/organizations/${orgId}/organization-trials/${orgTrialId}/care-team`,

  create(orgId, careTeamMember) {
    return viperApi.post(this.basePath(orgId, careTeamMember.orgTrialId), careTeamMember)
  },

  delete(orgId, orgTrialId, careTeamMemberId) {
    return viperApi.delete(`${this.basePath(orgId, orgTrialId)}/${careTeamMemberId}`)
  }
}
